import inIframe from './in-iframe'

export default (parentUrl, options) => {
  if (parentUrl && parentUrl.length) return parentUrl

  if (options.popup === 'true') return options.url

  if (inIframe) return window.document.referrer

  return window.location.toString()
}
